// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Bd3C","inputWrap":"CustomTip_inputWrap__Yxolu"};